// Per-tab page zoom + a find-in-page bar for the active proxied iframe.
// The proxied document is same-origin (served by the SW) so we can drive both.
import { active } from "./state.js";
import { frames } from "./view.js";

const MIN = 50, MAX = 200, STEP = 10;

export function applyZoom(frame, zoom) {
	if (!frame) return;
	if (frame.rvRemote) { frame.zoom(Number(zoom) || 100); return; } // sandbox mode: S zooms the page
	const z = (Number(zoom) || 100) / 100;
	try {
		const doc = frame.contentDocument;
		if (doc && doc.documentElement) { doc.documentElement.style.zoom = z; return; }
	} catch (e) {}
	frame.style.zoom = z;
}

export function zoomActive(dir) {
	const t = active();
	if (!t || !t.src) return;
	let z = Number(t.zoom) || 100;
	z = dir === 0 ? 100 : Math.max(MIN, Math.min(MAX, z + dir * STEP));
	t.zoom = z;
	applyZoom(frames.get(t.id), z);
}

// --- find in page ---------------------------------------------------------
let bar, input;
function build() {
	bar = document.createElement("div");
	bar.className = "rv-findbar"; bar.hidden = true;
	input = document.createElement("input");
	input.type = "text"; input.placeholder = "Find in page…"; input.setAttribute("aria-label", "Find in page");
	const next = mkBtn("▾", "Next", () => run(true));
	const prev = mkBtn("▴", "Previous", () => run(false));
	const close = mkBtn("✕", "Close", hideFind);
	bar.append(input, prev, next, close);
	document.body.appendChild(bar);
	input.addEventListener("keydown", (e) => {
		if (e.key === "Enter") { e.preventDefault(); run(!e.shiftKey); }
		else if (e.key === "Escape") { e.preventDefault(); hideFind(); }
	});
}
function mkBtn(label, aria, fn) {
	const b = document.createElement("button");
	b.className = "rv-find-btn"; b.textContent = label; b.setAttribute("aria-label", aria);
	b.addEventListener("click", fn);
	return b;
}
function run(forward) {
	const t = active();
	const f = t && frames.get(t.id);
	const q = input.value;
	if (!f || !q) return;
	if (f.rvRemote) { f.find(q, forward); return; }
	try { f.contentWindow.find(q, false, !forward, true, false, false, false); } catch (e) {}
}
export function openFind() {
	const t = active();
	if (!t || !t.src) return;
	if (!bar) build();
	bar.hidden = false;
	input.focus(); input.select();
}
export function hideFind() {
	if (bar) bar.hidden = true;
	const t = active();
	const f = t && frames.get(t.id);
	if (f && f.rvRemote) { f.findClose(); return; }
	try { if (f) f.contentWindow.getSelection().removeAllRanges(); } catch (e) {}
}
